module.exports = __webpack_public_path__ + "static/a-home-behind-the-lens-small-thumbnails-100x100-ec4d5737dbd4c82769ed8094f3b0fcd8.jpg";